import * as Url from "../Utils/UrlUtil";

export function ConfigureProcessListButtonsBasedOnSelectedRow(s: MVCxClientGridView, e: ASPxClientGridViewSelectionEventArgs, view: any) {
    if (s.GetSelectedRowCount() === 1) {
        let selectedKey = s.GetSelectedKeysOnPage()[0];

        let template: string = window.ETDR_RD.appConfig["UrlTemplate.DeleteProcess"];
        let href: string = Url.createUrlFromTemplate(template, { processId: selectedKey, view: view });

        $("#ProcessDeleteButton").attr("href", href);
        $('.gridaction.del').removeClass('disabled');
    } else {
        $("#ProcessDeleteButton").attr("href", "#");
        $('.gridaction.del').addClass('disabled');
    }
}
